var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"reg-card-header pt-3"},[(_vm.showImage)?_c('candidate-portal-logo'):_vm._e(),_c('div',{staticClass:"reg-title"},[_vm._t("default")],2),_c('div',{staticClass:"pt-2"},[_c('h3',[_vm._v(_vm._s(_vm.formName))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }